import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import plus from "../../Components/assets/icons/a1.png";
import colunms from "../../Components/assets/icons/LINES.png";
import eye from "../../Components/assets/icons/eye.png";
import pen from "../../Components/assets/icons/pen.png";
import basket from "../../Components/assets/icons/basket.png";
import search1 from "../../Components/assets/icons/search.png";
import top from "../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../assets/icons/circle.png";
import rigth from "../assets/icons/rigth.png";
import save from "../assets/icons/save.png";
import cancel from "../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../Header/Header";
import { faEye, faPen } from "@fortawesome/free-solid-svg-icons";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Offcanvas from "react-bootstrap/Offcanvas";

import toast, { Toaster } from "react-hot-toast";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Context } from "../../utils/context";
import ViewOffCanvance from "./ViewOffCanvance";
import { ApprovalStatus, formatDateTime, IDS } from "../../utils/common";
import { putData } from "../../utils/api";
import Editcommissionmodal from "./Editcommissionmodal";

library.add(fas);

// ********************************************************************************************************************************************************

const Tables = ({
  data,
  getDataAll,
  OrderByOptions,
  user,
  reset,
  setonPageChange,
  setChangeStatus,
  sortOrder,
  setSortOrder,
  resultsPerPageOptions,
  perPage,
  setperPage,
  setReset,
  hideFilter,
  setHideFilter,
  option,
  setStartDate,
  endDate,
  startDate,
  setEndDate,
  setSearch,
  search,
  currentPage,
  searchStore,
  setSearchStore,
  searchContact,
  setSearchContact,
  approval_status_id,
}) => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    IMG_URL,
    postData,
  } = useContext(Context);

  const [show, setShowAdd] = useState(0);
  const [show1, setShowEdit] = useState(0);
  // const [show2, setShowEditComm] = useState(0);
  const [show2, setShowEditComm] = useState(null);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/vendor/${id}`);
    setChangeStatus(response);
  };

  const ChangeApprovedStatus = async (id, status) => {
    const data = {
      approval_status_id: status,
    };
    const response = await putData(`/admin/vendor/approved-status/${id}`, data);
    setChangeStatus(response);
  };

  // Delete module.....................................................
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  // Modal function
  const handleClose = () => setShowAdd(0);
  const handleShow = (id) => {
    setShowAdd(id);
  };

  const handleClose2 = () => setShowEditComm(0);
  const handleShow2 = (id) => {
    setShowEditComm(id);
  };

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  const DeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/vendor/${recordToDeleteId}`);
      await ErrorNotify(recordToDeleteName);
      setChangeStatus(response);
      setRecordToDeleteId(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
  };

  //toggle/
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [view, setview] = useState(0);
  const handleViewClose = () => setview(false);

  const handleViewshow = async (id) => {
    await setview(id);
  };

  const navigate = useNavigate();
  return (
    <>
      <div className="">
        <div className="row">
          <div className="row mt-4">
            {/* <div className=" col-12">
              <div className="d-flex align-items-center mb-3">
                <div className="show me-2">
                  <p className="show m-0">Show</p>
                </div>
                <div className="number me-2 show_entry_div">
                  <select
                    className="form-select form-select-sm"
                    aria-label=".form-select-sm example"
                    onChange={(e) => setperPage(e.target.value)}
                  >
                    {option?.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="entries">
                  <p className="show m-0">entries</p>
                </div>
                <div className="sowing ms-3 me-2">
                  <p className="show m-0">{`Showing ${Math.min(
                    (currentPage - 1) * perPage + 1,
                  )} to ${Math.min(
                    currentPage * perPage,
                    data?.data?.total,
                  )} of ${data?.data?.total} entries`}</p>
                </div>
              </div>
            </div> */}
            <div className=" col-12">
              <div className="row align-items-end">
                {/* <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                            <div className="num" >
                              <Select
                                options={[
                                  { value: "ASC", label: "Low To High" },
                                  { value: "DESC", label: "High To Low" },
                                ]}
                                value={shortCommission}
                                placeholder="Commission"
                                onChange={(e) => {
                                  setShortCommission(e);
                                }}
                              />
                            </div>
                          </div> */}
                <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                  <div className="num">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      id=""
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setonPageChange(1);
                          getDataAll();
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                  <div className="num">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Shop Name"
                      id=""
                      value={searchStore}
                      onChange={(e) => {
                        setSearchStore(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setonPageChange(1);
                          getDataAll();
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                  <div className="num">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Contact No"
                      id=""
                      value={searchContact}
                      onChange={(e) => {
                        setSearchContact(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setonPageChange(1);
                          getDataAll();
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                  <div className="Search me-2">
                    <Button
                      type="button"
                      onClick={() => {
                        setonPageChange(1);
                        getDataAll();
                      }}
                      className="btn btn-search"
                    >
                      <img src={search1} className="search" alt="" />
                    </Button>
                  </div>
                  <div className="Search-1">
                    <button
                      type="button"
                      onClick={() => {
                        setSearch("");
                        setSearchStore("");
                        setSearchContact("");
                        setReset(!reset);
                      }}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-line mt-3"></div>
        <div className="row mt-3">
          <div className="data table-responsive">
            <Table striped bordered hover responsive center>
              <thead>
                <tr className="">
                  {visible.col1 && <th className="sr">Sr. No.</th>}

                  {visible.col3 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Date
                    </th>
                  )}
                  {visible.col3 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Name
                    </th>
                  )}
                  {visible.col4 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Shop Name
                    </th>
                  )}
                  {visible.col4 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Vendor Type
                    </th>
                  )}
                  {visible.col4 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Specialization Category
                    </th>
                  )}
                  {/* {visible.col10 && (
                              <th className="tax-name" style={{ width: "900px" }}>logo</th>
                            )} */}
                  {visible.col5 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Contact No
                    </th>
                  )}

                  {/* {visible.col9 && (
                              <th
                                className="tax-name"
                                style={{ width: "900px" }}
                              >
                                Commission %
                              </th>
                            )} */}
                  {/* {visible.col6 && (
                            <th className="tax-name">Password</th>
                          )} */}
                  {visible.col7 &&
                    approval_status_id === ApprovalStatus.Approved && (
                      <th className="tax-name" style={{ width: "900px" }}>
                        Status
                      </th>
                    )}
                  {/* {visible.col9 &&
                    approval_status_id === ApprovalStatus.Approved && (
                      <th className="tax-name" style={{ width: "900px" }}>
                        Commission
                      </th>
                    )} */}
                  {visible.col8 && (
                    <th className="tax-name" style={{ width: "900px" }}>
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {data?.data?.data?.length > 0 ? (
                  data.data.data.map((d, index) => {
                    return (
                      <tr className="" key={index}>
                        {visible.col1 && <td>{++index}.</td>}
                        {visible.col3 && (
                          <td>{formatDateTime(d?.updatedAt)}</td>
                        )}
                        {visible.col3 && <td>{d?.name}</td>}
                        {visible.col4 && <td>{d?.Shop_Detail?.shop_name}</td>}
                        {visible.col4 && <td>{d?.Vendor_Type?.name}</td>}
                        {visible.col4 && (
                          <td>{d?.Shop_Detail?.Category?.name || " NA"}</td>
                        )}
                        {/* {visible.col10 && <td>

                                  <img
                                    src={IMG_URL + d?.seller_detail?.logo}
                                    alt="Image"
                                    width="100"
                                    height="100"
                                  />

                                </td>} */}
                        {visible.col5 && <td>{d?.contact_no}</td>}

                        {/* {visible.col9 && (
                                  <td>
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span>{d?.commission}%</span>
                                      <Button
                                        onClick={() => handleShow1(d?.id)}
                                        type="button"
                                        className="btn btn-primary"
                                      >
                                        <img src={pen} className="pen" alt="" />
                                      </Button>
                                    </div>
                                  </td>
                                )} */}

                        {/* {visible.col6 && <td>{d?.password}</td>} */}

                        {visible.col7 &&
                          approval_status_id === ApprovalStatus.Approved && (
                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!isAllow.includes(IDS.Vendor.Edit)}
                                  role="switch"
                                  checked={d.status}
                                  onChange={() => {
                                    ChangeStatus(d.id);
                                  }}
                                  id={`flexSwitchCheckDefault${d?.id}`}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                >
                                  {d.status ? "Active" : "Inactive"}
                                </label>
                              </div>
                            </td>
                          )}
                          
                        {/* 
                        {visible.col9 &&
                        isAllow.includes(IDS.Vendor.Edit) &&
                          approval_status_id === ApprovalStatus.Approved && (
                            <>
                              <button
                                type="button"
                                className="btn-add-edit"
                                onClick={() => {
                                  setSelectedId(d?.id);
                                  setShowEditComm(d?.id);
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faPen}
                                  className="me-2"
                                />
                              
                              </button>
                              <span>
                                {" "}
                                {d?.commission_percentage || 0 + "%"}{" "}
                              </span>
                            </>
                          )} */}

                        {visible.col8 && (
                          <td>
                            {d?.id === 1 ? (
                              <></>
                            ) : (
                              <div className="d-flex align-items-center gap-3">
                                {isAllow.includes(IDS.Vendor.Edit) &&
                                  d.approval_status_id ===
                                    ApprovalStatus.Pending && (
                                    <div>
                                      <select
                                        className={
                                          d?.approval_status_id ===
                                          ApprovalStatus.Approved
                                            ? "status-holder shipped"
                                            : "status-holder Unshipped"
                                        }
                                        onChange={(e) =>
                                          ChangeApprovedStatus(
                                            d?.id,
                                            e.target.value,
                                          )
                                        }
                                        value={d?.Approval_Status?.id}
                                      >
                                        <option value={ApprovalStatus.Pending}>
                                          Inactive
                                        </option>
                                        <option value={ApprovalStatus.Approved}>
                                          Approved
                                        </option>
                                        <option value={ApprovalStatus.Rejected}>
                                          Rejected
                                        </option>
                                      </select>
                                    </div>
                                  )}

                                {isAllow.includes(IDS.Vendor.List) &&
                                  approval_status_id ===
                                    ApprovalStatus.Approved && (
                                    <button
                                      type="button"
                                      className="btn btn-add"
                                      onClick={() =>
                                        navigate(`/suggested-designs/${d?.id}`)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faEye}
                                        className="me-2"
                                      />
                                      View Designs
                                    </button>
                                  )}

                                {/* <Link
                                          type="button"
                                          to={`/design/${d?.id}`}
                                          className="me-5"
                                        >
                                          {" "}
                                          <FontAwesomeIcon
                                            icon={faEye}
                                            className="me-2"
                                          />{" "}
                                          View Designs
                                        </Link> */}

                                <div className="add me-3">
                                  {" "}
                                  {isAllow.includes(IDS.Vendor.List) ? (
                                    <Link type="button" className="btn btn-add">
                                      <div onClick={() => handleViewshow(d.id)}>
                                        View Details
                                      </div>
                                    </Link>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            )}
                          </td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-4">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {/* </section> */}
      {/* </div>
          </div>
        </section>
      </div> */}

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show2 ? (
        <Editcommissionmodal
          handleClose={handleClose2}
          setShow={setShowEditComm}
          show={show2}
          selectedId={selectedId}
        />
      ) : null}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <Toaster position="top-right" />

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button className="btn btn-yes me-2" onClick={DeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {view ? (
        <ViewOffCanvance
          handleClose={handleViewClose}
          setShow={setview}
          show={view}
          id={view}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Tables;
